<template>
  <div>
    <div class="topbar">
      <i @click="goHome"></i>
      <!-- <span>{{$t('nav_name')}}</span> -->
      <div class="mainBox1">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een" v-if="$i18n.locale != 'he'"></em>
          <ul v-if="$i18n.locale != 'he'" v-show="changeLangBox" class="chooseLangUl">
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mainBox">
      <div class="signInBox" v-if='showVIPType == 12'>
        <div class="forgetPsd1">{{ $t("annual_membership") }}</div>
        <p style="line-height:150%; font-size:160%;color:#37c2e5">请扫描或长按识别下方二维码</p>
        <p style="line-height:150%;font-size:160%;color:#37c2e5">购买ICode年费会员</p>
        <img style="margin-top: 10%" :src="imgurl" alt="">
        <span v-show="s1Showpwd" id="france" class="s1">
            {{ $t("signup_txt7") }}
          </span>
      </div>
      <div class="signInBox" v-else-if='showVIPType == 3'>
        <div class="forgetPsd1">{{ schoolId == "433756" ? "模拟训练季卡" : $t("season_membership") }}</div>
        <p style="line-height:150%;font-size:160%;color:#37c2e5">请扫描或长按识别下方二维码</p>
        <p style="line-height:150%;font-size:160%;color:#37c2e5">{{ schoolId == "433756" ? "购买模拟训练季卡" : "购买ICode季度会员" }}</p>
        <img style="margin-top: 10%" :src="imgurl" alt="">
        <span v-show="s1Showpwd" id="france" class="s1">
            {{ $t("signup_txt7") }}
          </span>
      </div>
      <div class="signInBox" v-else>
        <div class="forgetPsd1"></div>
        <p style="line-height:150%;font-size:160%;color:#37c2e5">暂时无法购买会员</p>
        <p style="line-height:150%;font-size:160%;color:#37c2e5">请前往<a href="https://home.icode.org.cn/wechat" style="color:white;">学习平台</a>咨询客服</p>
        <img style="margin-top: 10%" src="" alt="">
        <span v-show="s1Showpwd" id="france" class="s1">
            
          </span>
      </div>
    </div>
<!--    <el-button type="text" @click="open">点击打开 Message Box</el-button>-->
    <LeapPopup
        v-show="maskBox"
        @onOK="logOut"
        :title="$t('timeout01')"
        :content="$t('timeout02')"
        :cancelButtonTxt="$t('timeout04')"
        :okButtonTxt="$t('timeout03')"
        :isConfirm="false"
    ></LeapPopup>
  </div>
</template>

<script>
import store from "../store";
import { mapGetters } from "vuex";
import md5 from "js-md5";
import Axios from "axios";
Axios.defaults.withCredentials = true;
import I18nUtils from "@/utils/i18nUtils";

export default {
  data() {
    return {
      expireTime:'',
      time:'',
      imgurl:'',
      emailShowtext: "",
      s1Show: false,
      s1Showpwd: false,
      myOrotherShow: true,
      email: "",
      password: "",
      passwordSwitch: false,
      phone: "",
      emailReg: false,
      pwdReg: false,
      phoneReg: false,
      warning: "",
      warnShow: false,
      changeLangBox: false,
      langList: I18nUtils.langList,
      schoolId: sessionStorage.getItem("schoolId"),
      schoolProduct: {
        "3570": "9",
        "433756": "10"
        },
      vipType: { //数字表示VIP月数
        "3570": 12,
        "433756": 3
      },
      showVIPType: null
    };
  },

  mounted() {
    this.getCode()
    I18nUtils.initLanguage(this);

    this.emailShowtext = this.$t("signup_txt13");
    this.time =  window.setInterval(()=>{
      this.getOrder()
    },1000)
  },

  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },
    
    //提示
    open() {
      this.$alert('您的会员到期时间为：'+this.expireTime, '支付成功', {
        confirmButtonText: '确定',
        callback: action => {
          this.$router.push({path: '/index'})
        }
      });
    },
    // 查询订单状态
    getOrder() {
      this.$http
          .getAxios("/wx/getOrderStatus", {
            method: "post",
          })
          .then((res) => {
            if(res.data.code == 0){
              window.clearInterval(this.time)
              this.expireTime = new Date( res.data.data.expireTime*1000 ).toLocaleString()
              this.open()
            }
          });
    },
    // 登出
    logOut() {
      this.$http
          .getAxios("/user/logout", {
            method: "post",
          })
          .then((res) => {
            var res = res.data;
            if (res.code == "0") {
              // this.channel.clear(); //清空数据
              store.commit("toggleMaskState", false);

              sessionStorage.removeItem("gameId");
              sessionStorage.removeItem("level");

              this.$router.push({ path: "/" });
            }
          });
    },
    //获取二维码
    getCode(){
      this.showVIPType = this.vipType[this.schoolId];
      var getMsg = "wx/getPayQrCode02?productId=" + this.schoolProduct[this.schoolId];
      this.$http.getAxios.get(getMsg).then(res=>{
        if(res.data.code == 0){        
          this.imgurl =res.data.msg;
        }
      })
    },


    testClick() {
      this.$store.dispatch("updateICodeName").then(() => {
      });
    },
    // 忘记密码
    forgotPwd() {
      this.$router.push({ path: "/forgotPwd" });
    },

    // 注册
    toSignUp() {
      this.$router.push({ path: "/signUp" });
      // }
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
    // 手机号
    checkphone() {
      // let reg = /^\d+$|^\d+[.]?\d+$/;
      this.warnShow = false;
      if (this.phone != "") {
        this.phoneReg = true;
        this.s1Show = false;
        this.emailReg = true;
      } else {
        this.phoneReg = false;
        this.s1Show = true;
        this.emailShowtext = this.$t("signup_txt13");
      }
    },
    // 邮箱验证
    checkEmail() {
      let reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      this.warnShow = false;
      if (reg.test(this.email)) {
        this.s1Show = false;
        this.emailReg = true;
      } else {
        this.s1Show = true;
        if (this.email == "") {
          this.emailShowtext = this.$t("signup_txt13");
        } else {
          this.emailShowtext = this.$t("forPass_note2");
        }
      }
    },
    // 邮箱验证
    checkEmail1() {
      this.s1Show = true;
      this.warnShow = false;
      this.emailShowtext = this.$t("signup_txt13");
    },
    checkPwd() {
      let reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/;
      this.warnShow = false;
      if (reg.test(this.password)) {
        this.s1Showpwd = false;
        this.pwdReg = true;
      } else {
        this.pwdReg = false;
        this.s1Showpwd = true;
      }
    },
    checkPwd1() {
      this.s1Showpwd = true;
      this.warnShow = false;
    },
    showPwdSwitch() {
      this.passwordSwitch = !this.passwordSwitch;
    },
    // 登录  signin_note5
    loginIndex() {

      if (this.phoneReg && this.pwdReg) {
        // var emailOrphone = ''
        // this.$i18n.locale == 'zh'? emailOrphone = this.phone : emailOrphone = this.email;
        this.$http
          .getAxios("/user/userLogin", {
            method: "post",
            data: {
              email: this.phone,
              password: md5(this.password),
            },
          })
          .then((res) => {
            var res = res.data;
            if (res.code == "0") {
              document.cookie=`USERID=${res.data}`
              store.commit("toggleMaskState", false);
              localStorage.setItem("competeObj", JSON.stringify(res.data));
              localStorage.setItem("signIn", "1");

              // www学习中心跳转
              let m = localStorage.getItem("modes"),
                g = sessionStorage.getItem("gameId"),
                l = sessionStorage.getItem("level");
              // 如果session中同时存在mode、gameId和level值且不为0，
              // 则表明是从 www学习中心 -> monthly页面 -> signIn登录页 -> monthly页面
              if (m && g && l && g !== 0 && l !== 0) {
                this.$router.push({
                  path: "/monthly?g=" + g + "&m=" + m + "&level=" + l,
                });
              } else {
                // 否则视为正常登录，
                // 从 /根目录页 -> signIn登录页 -> index首页
                this.$router.push({ path: "/index" });
              }
            } else if (res.code == "46") {
              this.warnShow = true;
              this.warning = this.$t("signin_note5");
            } else if (res.code == "47") {
              this.warnShow = true;
              this.warning = this.$t("signin_note4");
            } else if (res.code == "48") {
              this.warnShow = true;
              this.warning = this.$t("signin_note5");
            } else if (res.code == "49") {
              this.warnShow = true;
              this.warning = this.$t("signin_note50");
            }
            // 原逻辑：试用账号无手机号自动跳转至手机号绑定页面，
            // 【试用账号：没有手机号且不是会员的帐号,res.code=108，另一种没有手机号且是会员的帐号,res.code=0.】
            //  else if (res.code == "108") {
            //   this.warnShow = true;
            //   this.warning = this.$t("star_txt11");
            //   setTimeout(() => {
            //     this.$router.push({ path: "/bindaccount" });
            //   }, 1000);
            // }
            //  目前修改为试用账号仅有在学习平台首页进入晋级赛时才绑定手机号
            else if (res.code == "108") {
              store.commit("toggleMaskState", false);
              localStorage.setItem("signIn", "1");

              this.$router.push({ path: "/index" });
            } else if (res.code == "53") {
              this.warnShow = true;
              this.warning = "请用邮箱登录";
              this.phone = "";
              this.password = "";
            } else if (res.code == "96") {
              this.$router.push({ path: "/modifyMsg" });
            } else {
              this.warnShow = true;
              this.warning = this.$t("bad_network");
            }
          });
      } else if (this.password == "") {
        this.s1Showpwd = true;
      }
    },
    moreLang() {
      this.changeLangBox = !this.changeLangBox;
      this.settingBoxVis = false;
    },

  },

  computed: {
    ...mapGetters(["maskBox", "name", "userType"]),
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  width: 100%;
  height: 60px;
  color: #aaf9fe;
  background: #122346;
  i {
    position: absolute;
    top: 8px;
    left: 40px;
    width: 172px;
    height: 46px;
    cursor: pointer;
    z-index: 99999999999999999;
    background: url("~@/assets/images/bigIcon.png") no-repeat center;
  }
}
.fr {
  width: 473px !important;
}
.mainBox1 {
  height: 60px;
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 323;
}
.topbar span {
  font-size: 20px;
  line-height: 60px;
  margin-left: 100px;
}
.mainBox {
  // width: 1200px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.forgetPsd1 {
  margin-left: 15px;
  width: 453px;
  height: 58px;
  background: url("~@/assets/images/title.png") no-repeat center;
  font-size: 38px;
  font-weight: 700;
  text-align: center;
  line-height: 58px;
  color: #37c2e5;
  margin-bottom: 50px;
}
.signInBox {
  width: 480px;
  padding: 30px 50px 0;
  height: 360px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -290px;
  margin-top: 120px;
  text-align: center;
  padding-bottom: 100px;
}
.inputItem {
  // padding: 10px 0;
  position: relative;
  margin-bottom: 34px;
  text-align: center;
  input {
    width: 320px;
    padding-left: 154px;
    height: 56px;
    background-color: #ffffff;
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    line-height: 56px;
    font-size: 16px;
    border: 0;
  }
  .s1 {
    position: absolute;
    left: 20px;
    bottom: -26px;
    font-size: 14px;
    color: red;
  }
  ::-webkit-input-placeholder {
    color: #999999;
  }
  :-moz-placeholder {
    color: #999999;
  }
  :-ms-input-placeholder {
    color: #999999;
  }
  .account {
    width: 142px;
    height: 33px;
    position: absolute;
    top: 11px;
    line-height: 33px;
    left: 0px;
    font-size: 16px;
    color: #010101;
    border-right: 1px solid #999999;
  }
  .pwdSwitch {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
  }
}
.moreOption {
  font-size: 16px;
  color: #fff;
  padding: 10px 0 30px;
  span {
    text-decoration: underline;
    padding: 0 10px;
    cursor: pointer;
    &:nth-of-type(1) {
      float: left;
    }
    &:nth-of-type(2) {
      float: right;
    }
  }
}
.s11 {
  width: 700px;
  margin-left: -102px;
  display: block;
  margin-top: 20px;
  font-size: 18px;
  color: red;
}
.signIn {
  width: 463px;
  height: 59px;
  background-color: #2d8c9e;
  border-radius: 29px;
  color: #fff;
  margin: 0 auto;
  border: 0;
  display: block;
  font-size: 20px;
  cursor: pointer;
}
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  line-height: 60px;
}
.chooseLangUl {
  position: absolute;
  z-index: 111;
  li {
    height: 40px;
    cursor: pointer;
  }
}
.settingBtn,
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  padding-right: 20px;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
  box-shadow: 0 0 0 1000px white inset;
}
</style>



// WEBPACK FOOTER //
// src/components/renew.vue